export default "__VITE_ASSET__493abf48__"